export default __webpack_public_path__ + "794721f414044815aada6bf78c4fce36.png";